module.exports = __webpack_public_path__ + "img/design-image-desktop.png";